import { INVOICE_REPORT } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  invoiceReports: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const invoiceReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case INVOICE_REPORT.REQUEST: {
      return { ...state, isLoading: true };
    }

    case INVOICE_REPORT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        invoiceReports: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case INVOICE_REPORT.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default invoiceReportReducer;
